import React from 'react';

import DeleteInvoiceProductModal from './DeleteInvoiceProductModal';

const DeleteInvoiceProductModalContainer = ({ onClose, ...restProps }) => {
  return <DeleteInvoiceProductModal {...restProps} onClose={onClose} />;
};

export default React.memo(DeleteInvoiceProductModalContainer);
